export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevronRight.454783ac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};